const ITEMS = ['Golden Raja', 'Live Draw', 'Sikkim', '11 AM', '12 PM', '5 PM', '7 PM'];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif-lux px-8 text-3xl italic text-[#F5F5F5] md:text-4xl">
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-[#D4AF37]" />
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-white/10 bg-[#050505] py-8"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
